var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 6.25C10 7.86083 8.69419 9.16666 7.08335 9.16666C5.47252 9.16666 4.16669 7.86083 4.16669 6.25C4.16669 4.63916 5.47252 3.33333 7.08335 3.33333C8.69419 3.33333 10 4.63916 10 6.25Z",
    stroke: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9524 16.6667H3.2143C2.35958 16.6667 1.66669 16.0271 1.66669 15.2381C1.66669 13.2657 3.39892 11.6667 5.53574 11.6667H8.63094C9.50194 11.6667 10.3058 11.9323 10.9524 12.3807",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.1667 11.6667V16.6667M16.6667 14.1667H11.6667",
    stroke: "#111827",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/invite-icon.8e0a88a10c19f62a213bc8a0947c2bd6.svg";
export { ForwardRef as ReactComponent };